import { LeaderboardEntries } from "../../../components/Storefront/ParticipantProfileUI";

const leaderboardEntries: LeaderboardEntries = {
  top_sales: [
    {
      id: 2321,
      name: "Ethan Caldwell",
      image: "",
      amount_raised: 1296,
    },
    {
      id: 2173,
      name: "Maya Thornton",
      image: "",
      amount_raised: 755,
    },
    {
      id: 2016,
      name: "Lucas Bennett",
      image: "",
      amount_raised: 623,
    },
    {
      id: 1935,
      name: "Noah Whitaker",
      image: "",
      amount_raised: 569,
    },
    {
      id: 1968,
      name: "Evelyn Crawford",
      image: "",
      amount_raised: 530,
    },
  ],
  top_profit: [
    {
      id: 2321,
      name: "Ethan Caldwell",
      image: "",
      amount_raised: 648,
    },
    {
      id: 2173,
      name: "Maya Thornton",
      image: "",
      amount_raised: 416,
    },
    {
      id: 2016,
      name: "Lucas Bennett",
      image: "",
      amount_raised: 338.5,
    },
    {
      id: 1896,
      name: "Mason Hartley",
      image: "",
      amount_raised: 302.9,
    },
    {
      id: 1968,
      name: "Evelyn Crawford",
      image: "",
      amount_raised: 301,
    },
  ],
  top_non_donation_sales: [
    {
      id: 2321,
      name: "Ethan Caldwell",
      image: "",
      amount_raised: 1296,
    },
    {
      id: 2173,
      name: "Maya Thornton",
      image: "",
      amount_raised: 615,
    },
    {
      id: 2016,
      name: "Lucas Bennett",
      image: "",
      amount_raised: 533,
    },
    {
      id: 1935,
      name: "Noah Whitaker",
      image: "",
      amount_raised: 519,
    },
    {
      id: 2137,
      name: "Evelyn Crawford",
      image: "",
      amount_raised: 438,
    },
  ],
};
export default leaderboardEntries;
